import React from "react"
import Layout from "../components/Layout"
import "../css/projects/pythonprojectcard.css"
import { Link } from "gatsby"
import Particle7 from "../components/Particle7"
import SEO from "../components/SEO"

const Pythonprojectcard = () => {
    return (
        <Layout>
            <SEO
                title="Python Projects"
                description="This Page is for Python Project Ocean."
            />
            <Particle7></Particle7>
            <h6>s</h6>
            <div className="programming-projectp">
                <h1>Natural language Projects</h1>
            </div>

            <div className="favp noSelect">
                <h3>
                    Those projects having a{" "}
                    <span role="img" aria-label="Heart">
                        ❤️
                    </span>{" "}
                    on them... come under the Favourite category.{" "}
                </h3>
            </div>

            <section className="most-likedp noSelect">
                <h3 className="totalp">Total Models :- 2</h3>
                <div className="rowp">
                    <div className="rotatep">
                        <div className="coffee-cardp">
                            <div className="card-headerp">
                                <h3 className="title-textp">
                                    SMS Spam Collection
                                    <span role="img" aria-label="Heart">
                                        ❤️
                                    </span>
                                </h3>
                            </div>
                            <div className="nlp-img1"></div>
                            <div className="backp">
                                <div className="back-contentp">
                                    <div className="layer"></div>
                                    <h4 className="textp">Checkout here...</h4>
                                    <div className="bttn-boxp">
                                        <a
                                            href="https://github.com/arpitsomani8/Natural-Language-Processing/tree/master/SMS%20Spam%20Collection-NLP"
                                            className="btnttp"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Github Code
                                        </a>


                                        <Link to="/nlp_model1/" className="btnttp">
                                            More Detail
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="rotatep">
                        <div className="coffee-cardp">
                            <div className="card-headerp">
                                <h3 className="title-textp">
                                    Yelp Business Reviews

                                </h3>
                            </div>
                            <div className="nlp-img2"></div>
                            <div className="backp">
                                <div className="back-contentp">
                                    <div className="layer"></div>
                                    <h4 className="textp">Checkout here...</h4>
                                    <div className="bttn-boxp">
                                        <a
                                            href="https://github.com/arpitsomani8/Natural-Language-Processing/tree/master/Yelp%20Business%20Reviews%20-%20NLP"
                                            className="btnttp"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Github Code
                                        </a>


                                        <Link to="/nlp_model2/" className="btnttp">
                                            More Detail
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </section>
        </Layout>
    )
}

export default Pythonprojectcard
